export default __webpack_public_path__ + "static/media/kyc.13d3fc63.svg";